<template lang="pug">
  .container-type
    .container-type_title
      span {{$t(title)}}
      tooltip-icon(:text="hint")
    .container-type_desription {{$t(description)}}
</template>
<script>
import { mapGetters } from 'vuex';
import TooltipIcon from '../../_common/ui/TooltipIcon';
import EquipmentCategories from '../../../common/EquipmentCategories';

export default {
  name: 'ContainerType',
  components: { TooltipIcon },
  computed: {
    ...mapGetters([
      'containerType'
    ]),

    title() {
      return this.containerType ? (this.containerType.improved ? 'CONTAINER_TYPE_IMPROVED' : 'CONTAINER_TYPE_STANDARD') : ''
    },

    hint() {
      return EquipmentCategories.getCategory('container').hint
    },

    description() {
      return this.containerType ? (this.containerType.improved ? 'SANDWICH_PANEL_WALLS' : 'WOODEN_WALLS') : ''
    }
  }
}
</script>
